import { render, staticRenderFns } from "./recupararSenha-entradas.vue?vue&type=template&id=31395cce&scoped=true&"
import script from "./recupararSenha-entradas.vue?vue&type=script&lang=js&"
export * from "./recupararSenha-entradas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31395cce",
  null
  
)

export default component.exports